module.exports = __webpack_public_path__ + "img/ellipses-multicolor.e289d609.svg";